import type { IconProps } from '../create-icon'

export function PUBGLogo({
  size = 24,
  color = 'currentColor',
  className,
  style,
  ...rest
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      className={className}
      style={style}
      {...rest}
    >
      {/* PUBG helmet silhouette */}
      <path d="M12 2C7.58 2 4 5.58 4 10v1c0 .55.45 1 1 1h1v3c0 1.1.9 2 2 2h1v3h6v-3h1c1.1 0 2-.9 2-2v-3h1c.55 0 1-.45 1-1v-1c0-4.42-3.58-8-8-8zm-4 9V10c0-2.21 1.79-4 4-4s4 1.79 4 4v1H8zm8 4H8v-2h8v2z" />
    </svg>
  )
}
